import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './Success.css';

const PurchaseSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Session ID validates successful payment
    if (!sessionId) {
      navigate('/subscription');
    }
  }, [sessionId, navigate]);

  return (
    <div className="success-container">
      <div className="success-card">
        <div className="success-icon">🚀</div>
        <h1>Boost Activated!</h1>
        <p className="success-message">
          Your profile is now boosted! You'll get significantly more visibility and matches.
        </p>

        <div className="success-features">
          <h3>Boost Benefits:</h3>
          <ul>
            <li>✓ 10-20x more profile views</li>
            <li>✓ Priority placement in browse queue</li>
            <li>✓ Active for 24-48 hours</li>
            <li>✓ More matches guaranteed</li>
          </ul>
        </div>

        <div className="success-actions">
          <button
            className="primary-button"
            onClick={() => navigate('/browse')}
          >
            Start Browsing
          </button>
          <button
            className="secondary-button"
            onClick={() => navigate('/subscription')}
          >
            Back to Subscription
          </button>
        </div>
      </div>
    </div>
  );
};

export default PurchaseSuccess;
